<div class="column" [ngClass]="isLoggedIn ? '' : 'right-signup'">
  <section id="booked" class="bg-grey">
    <div>
      <div>
        <div class="text-center" *ngIf="!isLoggedIn">
          <h1 class="font-color-teracotta">Your session has been booked!</h1>
        </div>
        <div class="col text-center desktop-hide">
          <img src="assets/images/process-step-four.png" class="img-fluid step-image-padding">
        </div>
        <div class="col text-center mobile-hide">
          <img src="assets/images/progress_step_four.svg" class="img-progress">
        </div>
        <div class="text-center loggedIn-header" *ngIf="isLoggedIn">
          <h1 class="">Your session has been booked!</h1>
          <img src="assets/images/booked.png" class="booked-img">
        </div>
        <div class="col text-center" *ngIf="!isLoggedIn">
          <h2 class="booked-text font-color-teracotta">Press Continue to enter your profile</h2>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button type="button" class="btn btn-primary continue-btn" (click)="gotoUpcoming()">Continue</button>
        </div>
      </div>
    </div>
  </section>
</div>
